/*
** Loader
*/

// State
const state = {
    loading: 0,
}

// Getters
const getters = {
    isLoading: state => state.loading > 0,
    loadCount: state => state.loading,
}

// Actions
const actions = {
    startLoad(store) {
        store.commit('updateLoad', store.state.loading + 1)
    },
    endLoad(store) {
        store.commit('updateLoad', store.state.loading - 1)
    },
    resetLoad(store) {
        store.commit('updateLoad', 0)
    },
}

// Mutations
const mutations = {
    updateLoad(state, value) {
        // console.log('updateLoad', value)
        state.loading = value
    },
}

// Export module
export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
}
